import React from 'react';
import { Section, TwoColumns } from '../Section';
import { SectionSubtitle } from '../Typography';
import { BulletsPoints } from '../DescriptionBlock/index';
import sizes from 'src/style/sizes';
import { mediaQueries } from 'src/style/breakpoints';

const BestConditions = React.memo(({ isFullTimePage }) => {
  return (
    <Section
      theme="light"
      css={{
        paddingBottom: 70,
        paddingTop: 70,
        [mediaQueries.tabletLandscapeUp]: {
          // paddingTop: 279,
        },
      }}
    >
      <TwoColumns
        sizeLeft={sizes.columnWidth.large}
        center
        left={
          <SectionSubtitle>
            Programmez votre réussite <br />
            dans les meilleures conditions
          </SectionSubtitle>
        }
        sizeRight={sizes.columnWidth.small}
        right={
          <div
            css={{
              [mediaQueries.tabletLandscapeUp]: {
                paddingLeft: 64,
              },
            }}
          >
            <BulletsPoints>
              Enseignement{' '}
              {isFullTimePage && (
                <>
                  <b>en présentiel</b> ou&nbsp;
                </>
              )}
              <b>à distance</b>
            </BulletsPoints>
            <BulletsPoints>
              Un ratio de <b>1 formateur pour 10 élèves</b>
            </BulletsPoints>
            <BulletsPoints>
              Un <b>accès à vie</b> à la plateforme de cours
            </BulletsPoints>
            <BulletsPoints>
              Plus de <b>100 heures</b> de vidéos bonus
            </BulletsPoints>
          </div>
        }
      />
    </Section>
  );
});

export default BestConditions;
